// src/components/ContactCard/ContactCard.js
import React from "react";
import "./ContactCard.css";

const ContactCard = () => {
  return (
    <div className="contact-page">
      <div className="contact-card shadow-lg">
        
        {/* Avatar / logo */}
        <div className="contact-avatar">
          <div className="avatar-square">
  <img src="https://datados.es/logo_brain_only_cuadrado.png" alt="Logo" />
</div>

        </div>

        {/* Nombre y título */}
        <h1 className="contact-name">
          J. Humberto Márquez Vacaflor Usandivaras Iriberri
        </h1>
        <p className="contact-role">
          Fundador y Consultor de DataDos - IA / Big Data / ML / Data Science
        </p>

        {/* Botón “Añadir contacto” */}
        <a
          className="btn btn-primary contact-main-btn"
          href="/contact/jhumberto.php"          
        >
          Añadir contacto
        </a>


        <p className="contact-subtitle">
          Impulsa el crecimiento con Inteligencia Artificial
        </p>

        {/* Datos */}
        <div className="contact-info">
          <div className="contact-row">
            <span className="label">Teléfono</span>
            <span className="value">+34 628 852 662</span>
          </div>
          <div className="contact-row">
            <span className="label">Email</span>
            <a href="mailto:info@datados.es" className="value link">
              info@datados.es
            </a>
          </div>
          <div className="contact-row">
            <span className="label">Web</span>
            <a href="https://datados.es" className="value link">
              datados.es
            </a>
          </div>
          <div className="contact-row">
            <span className="label">Ubicación</span>
            <span className="value">
              Las Palmas de Gran Canaria, España
            </span>
          </div>
          <div className="contact-row">
            <span className="label">Descripción</span>
            <span className="value">
              Consultor de IA / Big Data / ML / Data Science
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
